$.fn.contentSelectCategory = function(options) {
    options = $.extend({
        innerReceiver: '.content-loader',
        onLoad: $.noop
    }, options);

    var currentSelect;
    var currentPaginate;

    function isLoading() {
        return currentSelect.data('disabled');
    }

    function startLoading() {
        currentSelect.data('disabled', true);
    }

    function stopLoading() {
        currentSelect.data('disabled', false);
    }

    function selectOption() {
        if (!isLoading()) {
            startLoading();

            var item = $(this);

            var outerReceiver = $(currentSelect.data('receiver'));
            var innerReceiver;

            if (outerReceiver.find(options.innerReceiver).length == 0) {
                innerReceiver = outerReceiver;
            } else {
                innerReceiver = outerReceiver.find(options.innerReceiver);
            }

            var id = item.data('value');

            var ajaxUrl = "/a/" + $(currentSelect).data('content-select-category') + "/selectCategory";

            $.ajax({
                url: ajaxUrl,
                type: 'POST',
                dataType: 'json',
                data: {
                    'id': id
                },
                beforeSend: function() {
                    outerReceiver.animate({
                        'opacity': 0.5
                    }, 'slow');
                }
            }).done(function(data) {
                stopLoading();

                if (currentPaginate !== null) {
                    currentPaginate.data('categoryId', id);

                    currentPaginate.find('.paginate-left').addClass('disabled');

                    if (data.moreToLoadNext) {
                        currentPaginate.find('.paginate-right').removeClass('disabled');
                    } else {
                        currentPaginate.find('.paginate-right').addClass('disabled');
                    }
                }

                outerReceiver.stop(true, true).animate({'opacity': 1}, 'slow', function() {
                    var effectDirectionOne = 'down';
                    var effectDirectionTwo = 'up';

                    innerReceiver.hide('slide', {'direction': effectDirectionOne}, 'slow', function() {
                        innerReceiver.html(data.html).show('slide', {'direction': effectDirectionTwo}, function() {
                            options.onLoad.call(null, innerReceiver, event);
                        });
                    });
                });

                currentSelect.find('.content-select-category-item').removeClass('active');
                item.addClass('active');
            });
        }
    }

    return this.each(function(index, value) {
        currentSelect = $(this);

        var paginateName = currentSelect.data('content-select-category');
        currentPaginate = $("[data-paginate='"+paginateName+"']");

        currentSelect.on('click', '.content-select-category-item', selectOption);
    });
};
